<ng-container  *ngIf="!item['visible'] || (item.visible | async)">
    <div *hasRole="item.permission"
         matRipple
         class="nav-collapse-item"
    >
        <a class="nav-link" [routerLink]="[item.url]">
            <mat-icon class="nav-link-icon" *ngIf="item.icon">{{item.icon}}</mat-icon>
            <span class="nav-link-icon icon" *ngIf="item.faIcon">
                <fa-icon class="icon" icon="{{item.faIcon}}"></fa-icon>
            </span>
            <span class="nav-link-title">{{item.title}}</span>
        </a>
        <button mat-icon-button (click)="toggleOpen($event)">
            <mat-icon class="collapse-arrow">keyboard_arrow_right</mat-icon>
        </button>
    </div>


    <div class="children" [@slideInOut]="isOpen">
        <ng-container *ngFor="let item of item.children">
            <ngc-nav-item *ngIf="item.type=='item'" [item]="item"></ngc-nav-item>
            <ngc-nav-collapse *ngIf="item.type=='collapse'" [item]="item"></ngc-nav-collapse>
            <ngc-nav-group *ngIf="item.type=='group'" [item]="item"></ngc-nav-group>
        </ng-container>
    </div>
</ng-container>
